import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import useStyles from './OverlayHeader.styles';
import Button from '../../../UI/Button/Button';
import Translation from '../../lang/Translation';
import crossButton from '../ui/svg/close-icon.svg';

function OverlayHeader(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  return (
    <div className={classes.overlayHeader}>
      <div className={classes.label} id="overlayLabel__id" tabIndex={`${props.removeFocus ? '0' : '-1'}`}>
        {props.translationPlaceHolders ? props.title
          && <Translation placeholderValues={props.translationPlaceHolders}>{props.title}</Translation>
          : props.title && <Translation>{props.title}</Translation>}
      </div>
      <Button
        link
        noResize
        className={classes.exitButton}
        id="OverlayHeader__exit-button"
        onClick={props.exitButtonCallback}
      >
        {props.useCancelText && (
          <h5>
            <Translation optionalExtension={props.siteCode}>checkout.overlay.close.button</Translation>
          </h5>
        )}
        <img
          className={classes.buttonImage}
          src={crossButton}
          alt={Translation.getText('checkout.close.button')}
        />
      </Button>
    </div>
  );
}

OverlayHeader.propTypes = {
  title: PropTypes.string.isRequired,
  exitButtonCallback: PropTypes.func.isRequired,
  siteCode: PropTypes.string,
  useCancelText: PropTypes.bool,
  fullWidthOverlay: PropTypes.bool,
  removeFocus: PropTypes.bool,
  translationPlaceHolders: PropTypes.array,
};

OverlayHeader.defaultProps = {
  fullWidthOverlay: false,
};

export default OverlayHeader;
